module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"컨텐츠 새로 고침","touDialogConfirmLabel":"로그인 및 약관 동의","touDialogTitle":"Adobe Experience Cloud 사용 약관","touTextLine1":"Adobe Experience Cloud 사용 약관이 업데이트되었습니다.","touTextLine2a":"다음에 로그인하십시오.","touTextLine2b":"진행하기 전에 업데이트된 약관에 동의하십시오.","touTextLine3":"약관에 동의한 후, 컨텐츠 새로 고침을 클릭하십시오."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/ko_kr.json
// module id = 919
// module chunks = 0